<button class="header-icon" (click)="openNotificationCenter()" >
    <app-svg-icon [icon]="IconsConstants.NOTIFICATIONS_ICON"></app-svg-icon>
    <div class="notification-badge" *ngIf="unreadNotificationsCount > 0">{{unreadNotificationsCount}}</div>
</button>